import smoothscroll from 'smoothscroll-polyfill';

function initAnchorLinks() {
    const anchorLinks = document.querySelectorAll('[data-anchor-link]');

    // Polyfill for Safari
    if (!CSS.supports('scroll-behavior')) {
        // eslint-disable-line
        smoothscroll.polyfill();
    }

    anchorLinks.forEach((anchorLink) => {
        anchorLink.addEventListener('click', (event) => {
            event.preventDefault();

            const scrollToEl = document.querySelector(anchorLink.dataset.anchorLink);

            if (scrollToEl) {
                scrollToEl.scrollIntoView({ behavior: 'smooth' });
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initAnchorLinks();
});
